import { render } from "./WdwDynbox.vue?vue&type=template&id=6990d3aa&scoped=true"
import script from "./WdwDynbox.vue?vue&type=script&lang=js"
export * from "./WdwDynbox.vue?vue&type=script&lang=js"

import "./WdwDynbox.vue?vue&type=style&index=0&id=6990d3aa&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/wdw-vue build and deploy Teledata PROD/wdw-vue-widgets/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6990d3aa"]])

export default __exports__